import {FAMILY_COLLECTION_FILTER_ID} from '../components/Banner/Banner';

export const familyCollectionBadgeId = '55';
export const indexForDisplay = 7;
export const noDisplay = -1;

/**
 * @param listings - Conforms to Listing GraphQL schema: https://github.homeawaycorp.com/GraphQL/graphql-traveler-property/blob/master/lib/types/Listing.gql
 * @param filter - Conforms to node-search-url-parser SearchRequest.filter: https://github.homeawaycorp.com/traveler/node-search-url-parser/blob/master/lib/models/SearchRequest.js#L13
 */
export default function shouldDisplayAtIndex(listings, filter) {
    const hasBadgedListing = listings.some(
        (listing) =>
            // Listing.rankedBadges is a nullable field
            !!listing.rankedBadges &&
            listing.rankedBadges.some(
                (badge) => badge.id === familyCollectionBadgeId
            )
    );

    const hasFilter = filter.includes(FAMILY_COLLECTION_FILTER_ID);
    return hasBadgedListing && !hasFilter ? indexForDisplay : noDisplay;
}
